export default function Services() {
  const services = [
    {
      number: '01',
      title: 'AI Strategy & Advisory',
      description: 'We identify where intelligence creates the most impact—before any systems are built.'
    },
    {
      number: '02',
      title: 'Workflow Automation',
      description: 'Custom AI workflows that reduce manual work and improve consistency.'
    },
    {
      number: '03',
      title: 'Operational Optimization',
      description: 'Systems that improve internal efficiency, visibility, and control.'
    },
    {
      number: '04',
      title: 'AI Enablement & Support',
      description: 'Ongoing refinement, training, and optimization as your business grows.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-5xl font-serif font-bold text-midnight-navy text-center mb-16">
          What We <span className="text-wealth-gold">Do</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-soft-silver/50 rounded-lg p-8 hover:shadow-lg transition-all group cursor-pointer border border-transparent hover:border-wealth-gold">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-wealth-gold text-midnight-navy rounded-lg font-bold text-lg flex-shrink-0">
                  {index + 1}
                </div>
                <h3 className="text-2xl font-semibold text-midnight-navy group-hover:text-wealth-gold transition-colors">
                  {service.title}
                </h3>
              </div>
              <p className="text-slate-gray leading-relaxed ml-16">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
